export default "__VITE_ASSET__DutOptFF__"